import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import "@mdi/font/css/materialdesignicons.css";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  theme: {
    themes: {
      light: {
        primary: "#0079b5",
        secondary: "#607d8b",
        accent: "#03a9f4",
        error: "#f44336",
        warning: "#ff9800",
        success: "#4caf50",
      },
    },
  },
});
